import React from 'react';
import Hero from '../components/landing/Hero';
import Header from '../components/layout/Header';
import Institute from '../components/landing/Institute';
import Vision from '../components/landing/Vision';
import Platform from '../components/landing/Platform';
import CrisisGrid from '../components/landing/CrisisGrid';
import Manifesto from '../components/landing/Manifesto';
import FeaturedBlog from '../components/landing/FeaturedBlog';
import Roadmap from '../components/landing/Roadmap';
import Profile from '../components/landing/Profile';

// ... inside the return statement ...
{/* 06: Manifiesto */ }
<Manifesto />

{/* 06.5: Featured Blog */ }
<FeaturedBlog />

{/* 07: Roadmap */ }
<Roadmap />
import JoinNetwork from '../components/landing/JoinNetwork';

const Landing = () => {
    return (
        <div className="bg-background min-h-screen text-white selection:bg-primary selection:text-black">
            {/* Fixed Navigation */}
            {/* Fixed Navigation */}
            <Header />

            {/* 01: Hero - La Nueva Autoridad Técnica */}
            <Hero />

            {/* 02: Vehículo - Instituto de Innovación Iztacalco */}
            <Institute />

            {/* 03: La Tesis */}
            <Vision />

            {/* 04: Proyectos de Investigación */}
            <Platform />

            {/* 04.5: Featured Blog (Replaces Live Demo) */}
            <FeaturedBlog />

            {/* 05: Diagnóstico Crítico */}
            <CrisisGrid />

            {/* 06: Manifiesto */}
            <Manifesto />

            {/* 07: Roadmap */}
            <Roadmap />

            {/* 08: Director General */}
            <Profile />

            {/* 09: Colabora */}
            <JoinNetwork />

            {/* Footer */}
            <footer className="py-16 border-t border-zinc-900 bg-background">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                        {/* Brand */}
                        <div>
                            <div className="font-display font-bold text-2xl text-white mb-4">i³</div>
                            <p className="text-zinc-500 text-sm mb-4">
                                Instituto de Innovación Iztacalco A.C.
                            </p>
                            <p className="text-zinc-600 text-xs font-mono">
                                Organización sin fines de lucro
                            </p>
                        </div>

                        {/* Contacto */}
                        <div>
                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contacto</h4>
                            <p className="text-zinc-500 text-sm mb-2">📍 Iztacalco, CDMX, México</p>
                            <p className="text-zinc-500 text-sm mb-2">📧 hello [arroba] quantified.world</p>
                            <p className="text-zinc-600 text-xs font-mono mt-4">RFC: Pendiente registro</p>
                        </div>

                        {/* Legal */}
                        <div>
                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Legal</h4>
                            <ul className="space-y-2 text-sm">
                                <li><a href="/aviso-privacidad" className="text-zinc-500 hover:text-primary transition-colors">Aviso de Privacidad</a></li>
                            </ul>
                            <p className="text-zinc-700 text-xs font-mono mt-4">
                                ⚠️ No afiliado a ningún partido político
                            </p>
                        </div>

                        {/* Datos */}
                        <div>
                            <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Fuentes de Datos</h4>
                            <p className="text-zinc-600 text-xs font-mono leading-relaxed">
                                INEGI (Censo 2020) · CONEVAL (2022) · CDMX Open Data ·
                                Secretaría de Economía · IECM 2024
                            </p>
                            <p className="text-zinc-700 text-xs font-mono mt-3">
                                Última actualización: Enero 2026
                            </p>
                        </div>
                    </div>

                    {/* Bottom Bar */}
                    <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="text-zinc-600 text-sm font-mono">© 2026 Instituto i³ · Hecho con 🖤 en Iztacalco</p>
                        <p className="text-zinc-700 text-xs font-mono">
                            Desarrollado por <a href="https://quantified.world" target="_blank" rel="noopener" className="text-primary hover:underline">quantified.world</a>
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Landing;
